module.exports = __webpack_public_path__ + "img/arm-01-back.f5bb0aa8.png";